<template>
<div>

     <div
        style="border: 1px solid rgba(0,0,0,0.25); border-radius: 15px; display: flex; padding: 15px; height: 110px; cursor: pointer;"
        v-on:click="onClickPaymentMethod"
    >
        <div
            style="flex-grow: 0"
        >
            <v-icon
                v-if="card_image == null"
                size="64"
                style="padding-left: 30px; padding-right: 30px"
            >
                mdi-bank
            </v-icon> 

            <img 
                v-else
                :src="card_image"
                width="128"
            />
        </div>

        <div
            style="flex-grow: 1; margin-left: 15px;"
            v-if="value.payment_method_type == 'card'"
        >
            <b>{{value.customer_full_name}}</b><br/>
            x{{value.card_ending}} (expires {{value.card_exp_month}} / {{value.card_exp_year}})<br/>
            <span
                style="font-size: 12px"
            >
                Added to RedChirp: {{$rc.pretty(value.time_created,'date')}} @ {{$rc.pretty(value.time_created,'time')}}
            </span>
        </div>

        <div
            style="flex-grow: 1; margin-left: 15px;"
            v-else
        >
            <b>{{value.us_bank_account_bank_name}}</b><br/>
            x{{value.us_bank_account_ending}}<br/>
            <span
                style="font-size: 12px"
            >
                Added to RedChirp: {{$rc.pretty(value.time_created,'date')}} @ {{$rc.pretty(value.time_created,'time')}}
            </span>
        </div>

        <div
            style="flex-grow: 0; margin-right: 15px;"
        >
            <v-icon
                color="green"
                style="padding-top: 15px"
                v-if="value.is_active_payment_method"
                size="48"
            >
                mdi-check
            </v-icon>
        </div>
    </div>

</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return {}; }
        },
    },

    methods: {
        onClickPaymentMethod() 
        {
            if ( this.value.is_active_payment_method )
                return;

            this.$rc.confirm({
                'title': 'Change active payment method',
                'body': 'Make '+this.description+' your active RedChirp payment method?',
                'btn_text_ok': 'Yes',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doChangePaymentMethod();
                },
            });
        },

        doChangePaymentMethod()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/admin/red-chirp-payments/set-active-payment-method',
            
                'params' : {
                        'organization_id': this.value.linked_to_organization_id,
                        'payment_method_id': this.value.payment_method_id,
                    },
            
                'on_success': (data) => {
                        this.$emit('update');
                    },
            
                'on_error': 'Unable to change active payment method.',
            });
        },
    },

    computed: {
        card_image() 
        {
            if ( this.value.card_brand == null ) return null;

            if ( this.value.card_brand == 'amex' ) return '/app/payment-method-logos/american-express.svg';
            if ( this.value.card_brand == 'diners' ) return '/app/payment-method-logos/diners-club.svg';
            if ( this.value.card_brand == 'discover' ) return '/app/payment-method-logos/discover.svg';

            if ( this.value.card_brand == 'jcb' ) return '/app/payment-method-logos/jcb.svg';
            if ( this.value.card_brand == 'mastercard' ) return '/app/payment-method-logos/master-card.svg';
            if ( this.value.card_brand == 'unionpay' ) return '/app/payment-method-logos/unionpay.svg';
            
            if ( this.value.card_brand == 'visa' ) return '/app/payment-method-logos/visa.svg';

            return '/app/payment-method-logos/generic.svg';
        },

        description()
        {
            if ( this.value.card_brand != null )
            {
                return 'your '+this.value.card_brand+' ending in '+this.value.card_ending;
            }

            return 'your bank account with '+this.value.us_bank_account_bank_name +' ending in '+this.value.us_bank_account_bank_ending;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
